import React, { useCallback, useMemo } from 'react';
import { getColumns } from './columns';
import { Button } from 'semantic-ui-react';
import VirtualTable from 'components/VirtualTable/VirtualTable';
import { usePrintManifestAndPalletLabel } from 'hooks/usePrintManifestAndPalletLabel';
import TableWrapper from 'components/TableWrapper/TableWrapper';

export default function ManifestsTable({
  loading,
  hasNextPage,
  manifests,
  setPrinting = () => {},
  onLoadMoreItems = () => {},
}) {
  const { printManifestAndPalletLabel } =
    usePrintManifestAndPalletLabel(setPrinting);
  const renderActions = useCallback(
    (row) => {
      return (
        <Button
          circular
          icon="print"
          onClick={(event, data) => printManifestAndPalletLabel(row)}
        />
      );
    },
    [printManifestAndPalletLabel],
  );

  const columns = useMemo(() => getColumns(renderActions), [renderActions]);

  return (
    <TableWrapper>
      <VirtualTable
        loading={loading}
        tableClassNames="manifests-table"
        columns={columns}
        data={manifests}
        hasNextPage={hasNextPage}
        onLoadMoreItems={onLoadMoreItems}
      />
    </TableWrapper>
  );
}
